import React, { useEffect } from 'react'
import styles from './ResetUserCredentials.module.scss'
import { Translate } from 'react-localize-redux'
import {
    Button,
    ButtonType,
    Form,
    Icon,
    Radio,
    SubmitButton
} from '@digicert/dcone-common-ui'
import { faUser } from '@fortawesome/pro-light-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { translate } from 'shared/helpers/utils'
import { sendUsername, resendVerificationLink, resetMfaLink } from 'core/actions/Users.actions'
import { connect } from 'react-redux'
import { ResetUserCredentialsType } from '../user-overview/UserOverview.types'
import { IAccessScope } from 'reducers/Reducers.interfaces'
import { IAppState } from 'core/store/store'

const ResetUserCredentials = ({ user, onCancel, sendUsername, resendVerificationLink, resetMfaLink, profile }) => {

   useEffect(() => {
    setSelectedOption(null)
   }, [onCancel])
   
    const [selectedOption, setSelectedOption] = React.useState<ResetUserCredentialsType | null>(null)

    const sendMail = (event) => {
        event.preventDefault()
        switch (selectedOption) {
            case ResetUserCredentialsType.SendUsername:
                sendUsername(user.email, <Translate id={'notifications.users.sendUsernameSuccess'} data={{ email: user.email }} />)
                onCancel(event)
                break
            case ResetUserCredentialsType.ResetPassword:
                resendVerificationLink(user.id, user?.status === 'LOCKED', <Translate id={'notifications.users.resetPasswordSuccess'} data={{ email: user.email }} />)
                onCancel(event)
                break
            case ResetUserCredentialsType.ResetTwoFactor:
                resetMfaLink(user.id, user?.status === 'LOCKED', user.user_name,  <Translate id={'notifications.users.resetTwoFactorSuccess'} data={{ email: user.email }} />)
                onCancel(event)
                break
            default:
                break
        }
    }

    const canResendEmail = user?.access_scope === IAccessScope.system ? profile?.can_edit_system_user : profile?.can_edit_account_user

    return (
        <section className={styles.resetCredentialsOption}>
            <div className={styles.item}>
                <Icon icon={faUser as IconProp} className={styles.icon} />
                <div className={styles.info}>
                    <p className={styles.label}><Translate id='common.form.username' /></p>
                    <p className={styles.name}>{user.user_name}</p>
                </div>
            </div>
            <Form onSubmit={sendMail} className={styles.radioForm}>
                <p className={styles.label}><Translate id='notifications.users.credentials.title' /></p>
                <p className={styles.help}><Translate id='notifications.users.credentials.subTitle' /></p>

                <div className={styles.radioOption}>
                    <Radio
                        description={translate('notifications.users.credentials.sendUsernameDesc')}
                        label={translate('notifications.users.credentials.sendUsernameLabel')}
                        onChange={(event) => setSelectedOption(event.target?.value)}
                        value={ResetUserCredentialsType.SendUsername}
                        checked={selectedOption === ResetUserCredentialsType.SendUsername}
                    />
                </div>
                {(user?.can_unlock_with_password || user?.id === profile.id || (user.can_send_reset_password_email && canResendEmail)) && <div className={styles.radioOption}>
                    <Radio
                        description={translate('notifications.users.credentials.sendPasswordDesc')}
                        label={translate('notifications.users.credentials.sendPasswordLabel')}
                        onChange={(event) => setSelectedOption(event.target?.value)}
                        value={ResetUserCredentialsType.ResetPassword}
                        checked={selectedOption === ResetUserCredentialsType.ResetPassword}
                    />
                </div>}
                {(user?.reset_mfa || user?.can_unlock_with_mfa) && <>
                    <p className={styles.label}><Translate id='notifications.users.credentials.subHeading' /></p>
                    <p className={styles.help}><Translate id='notifications.users.credentials.heading' /></p>
                    <div className={styles.radioOption}><Radio
                        description={translate('notifications.users.credentials.resetTwoFactorDesc')}
                        label={translate('notifications.users.credentials.resetTwoFactorLabel')}
                        onChange={(event) => setSelectedOption(event.target?.value)}
                        value={ResetUserCredentialsType.ResetTwoFactor}
                        checked={selectedOption === ResetUserCredentialsType.ResetTwoFactor}
                    /></div>
                </>}

                <div className={styles.formActions}>
                    <Button buttonType={ButtonType.SECONDARY} onClick={onCancel}>
                        <Translate id='common.form.buttons.cancelBtn' />
                    </Button>

                    <SubmitButton disabled={!selectedOption}>
                        <Translate id='common.form.buttons.sendEmailBtn' />
                    </SubmitButton>
                </div>
            </Form>
        </section>
    )
}


export default connect(
    (state: IAppState) => {
        return {
            profile: state.profile.data,
        }
    },
    {
        sendUsername,
        resendVerificationLink,
        resetMfaLink
    })(ResetUserCredentials)

